import { render } from "./Docent.vue?vue&type=template&id=54b37f7e&scoped=true"
import script from "./Docent.vue?vue&type=script&lang=js"
export * from "./Docent.vue?vue&type=script&lang=js"

import "./Docent.vue?vue&type=style&index=0&id=54b37f7e&scoped=true&lang=css"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b37f7e"]])

export default __exports__